import { render, staticRenderFns } from "./CargoColegiadoNew.vue?vue&type=template&id=8aa0072e&scoped=true&"
import script from "./CargoColegiadoNew.vue?vue&type=script&lang=js&"
export * from "./CargoColegiadoNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8aa0072e",
  null
  
)

export default component.exports